module.exports = __webpack_public_path__ + "static/media/time-rptr.222c0c7b.svg";